// libs
import classNames from 'classnames'
import * as React from 'react'
import { useState } from 'react'

// components
import Icon from 'src/components/forms/icon/icon'
import { IRenderAPI } from 'src/components/_libs/popover_lib/popover_lib'
import Popover, { IProps as IPopoverProps } from 'src/components/popover/popover'
import { ShareTargetRow } from 'src/components/share/share_targets/share_targets'

// interfaces / constants
import { shareTexts } from 'src/components/share/lib/share_targets'
import { IShareOptions, useShare } from 'src/components/share/lib/use_share'
import { canShareNatively } from 'src/components/share/lib/utils'
import { CLASS_PREFIX } from 'src/constants/'

import './share_button.scss'

const cls = CLASS_PREFIX + 'share-button'

interface IProps extends IShareOptions {
  position?: IPopoverProps['position'];
  className?: string;
}

/**
 * The share button of tile, detail page and group header: opens the system share sheet where
 * the browser has one, the popover with the share targets everywhere else.
 */
const ShareButton: React.FC<IProps> = ({ position = 'top', className, ...options }) => {
  const { copyLink, openShareSheet, targets, track } = useShare(options)
  // once the sheet has failed, the popover takes over: opened in place, so the focused trigger
  // stays the same element, then toggled as usual
  const [sheetFailed, setSheetFailed] = useState(false)
  const sheetFirst = canShareNatively() && !sheetFailed

  return (
    <div className={classNames(cls, className)}>
      <Popover
        disabled={sheetFirst}
        position={position}
        align='relative-right'
        layout='round'
        trigger={({ show }: IRenderAPI) => (
          <button
            type='button'
            className={cls + '__button'}
            onClick={sheetFirst
              ? () => { openShareSheet(() => { setSheetFailed(true); show() }) }
              : undefined}
          >
            <Icon name='share-thick' size={22} />
            <span className={cls + '__text'}>{shareTexts.share}</span>
          </button>
        )}
      >
        <ShareTargetRow targets={targets} onTarget={track} onCopyLink={copyLink} />
      </Popover>
    </div>
  )
}

export default ShareButton
